export default {
  nav: {
    home: "Startseite",
    engines: "Motoren",
    transmissions: "Getriebe",
    bodyParts: "Karosserieteile",
    testimonials: "Kundenstimmen",
    contact: "Kontakt",
    getQuote: "Angebot anfordern",
    menu: "Menü umschalten",
  },
  banner: {
    text: "GROSSER AUSVERKAUF — Bis zu 30% RABATT auf ausgewählte Motoren, Getriebe & Karosserieteile. Versand in ganz Australien verfügbar.",
  },
  hero: {
    badge: "Vertrauenswürdig seit 2005",
    title1: "Gebrauchtmotoren in Spitzenqualität und",
    titleHighlight: "Getriebe",
    desc: "{{siteName}} ist Ihre zentrale Anlaufstelle für gebrauchte, neue und Aftermarket-Ersatzteile in Darwin. Spezialisiert auf die beliebtesten australischen Utes und SUVs.",
    contact: "Kontakt",
    browse: "Motoren ansehen",
  },
  about: {
    f1title: "Familiengeführt",
    f1text: "{{siteName}} ist ein familiengeführtes Unternehmen in Darwin, aufgebaut auf Vertrauen, harter Arbeit und echter Fürsorge für jeden Kunden.",
    f2title: "Reputation",
    f2text: "Wir geniessen einen starken Ruf, der auf Integrität, Fairness und technischem Know-how bei gebrauchten, neuen und Aftermarket-Teilen beruht.",
    f3title: "Was wir tun",
    f3text: "Wir sind Ihre zentrale Anlaufstelle für gebrauchte, neue und Aftermarket-Ersatzteile, unterstützt von einer spezialisierten Service- und Reparaturwerkstatt.",
    f4title: "Hochqualifiziert",
    f4text: "Unsere erfahrenen Techniker nutzen die neuesten Diagnoseprogramme und Scanner, um Ihnen unnötige Reparaturkosten zu ersparen.",
    stockLabel: "Was wir führen",
    modelsTitle: "Beliebte Modelle, die wir abdecken",
    modelsDesc: "Wir konzentrieren uns auf die meistverkauften australischen Utes und SUVs, damit Sie schnell das richtige Teil erhalten.",
  },
  why: {
    promise: "Unser Versprechen",
    title: "Warum uns wählen",
    w1title: "Qualität",
    w1text: "Beruhigende Gewissheit, dass Sie jedes Mal ein hochwertiges Teil und einen hochwertigen Service erhalten.",
    w2title: "Ersparnisse",
    w2text: "Behalten Sie mehr Geld in der Tasche mit unseren hervorragenden Rabatten auf alle Teile, neu und gebraucht.",
    w3title: "Garantie",
    w3text: "Neue Teile haben 12 Monate Garantie, gebrauchte Teile 3 Monate Garantie.",
    w4title: "Versand",
    w4text: "Kleine Teile werden über Nacht versandt, grössere Teile innerhalb von 1 bis 3 Tagen in ganz Australien.",
    missionTitle: "Unsere Mission",
    missionText: "Ihnen, unseren Kunden und der Gemeinschaft, einen erstklassigen Kundenservice zu bieten. Wir streben nach höchster Qualität in allem, was wir tun, um Ihnen bestmöglich zu dienen — durch unsere vier Werte-Säulen: Familie, Antrieb, Innovation & Qualität.",
    valuesTitle: "Unsere Werte",
    v1label: "Familie",
    v1text: "Wir sind ein Team, das sich um Kunden, Mitarbeiter und Lieferanten kümmert.",
    v2label: "Antrieb",
    v2text: "Wir streben nach dem Besten in allem, was wir tun, mit echter Leidenschaft für den Erfolg.",
    v3label: "Innovation",
    v3text: "Wir denken über den Tellerrand hinaus und arbeiten hart an kontinuierlicher Verbesserung.",
    v4label: "Qualität",
    v4text: "Wir bemühen uns, es gleich beim ersten Mal richtig zu machen.",
    t1text: "Toller Service. Reparatur noch am selben Tag erledigt und durchgehend mit mir kommuniziert — und das zu einem hervorragenden Preis!",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "Habe genau den Motor für meinen HiLux gefunden. Freundlich, ehrlich und wirklich kenntnisreich bei australischen Utes. Klare Empfehlung.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Sehr hilfsbereit, fair und ehrlich mit qualitativ hochwertigen Gebrauchtteilen für alle beliebten Modelle. Daumen hoch!",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Kam mit unbekannten Problemen und diese Jungs hatten mich schnell wieder fahrbereit. Fantastischer Service.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Teile für alle grossen Marken",
  },
  cta: {
    title: "Auf der Suche nach einem Teil?",
    desc: "Sagen Sie uns, was Sie brauchen, und unser Team besorgt es für Sie. Wir versenden in ganz Australien von unserer Werkstatt in Winnellie, Darwin.",
    request: "Angebot anfordern",
  },
  footer: {
    brandDesc: "Darwins vertrauenswürdige Quelle für hochwertige Gebrauchtmotoren, Getriebe und Karosserieteile. Familiengeführt und fokussiert auf die beliebtesten australischen Utes und SUVs.",
    quickLinks: "Schnellzugriff",
    company: "Unternehmen",
    getInTouch: "Kontakt aufnehmen",
    monFri: "Mo - Fr: 8:00 - 17:00 Uhr",
    copyright: "© Copyright {{year}} {{siteName}}. Alle Rechte vorbehalten.",
    disclaimer: "{{siteName}} ist ein unabhängiger Spezialist für Teile und Service.",
  },
  page: {
    enginesSubtitle: "Qualitativ hochwertige gebrauchte, neue und generalüberholte Motoren für alle Automarken und -modelle – europäisch, japanisch und amerikanisch. Jeder Motor wird geprüft, versiegelt und mit Garantie geliefert.",
    transmissionsSubtitle: "Gebrauchte und neue Automatik- und Schaltgetriebe für alle Marken und Modelle – europäisch, japanisch und amerikanisch. Jedes Getriebe wird geprüft, getestet und mit Garantie geliefert.",
    bodyPartsSubtitle: "Gebrauchte und Aftermarket-Karosserieteile, Stossfänger, Spiegel, Leuchten und Zierleisten für alle Marken und Modelle. Gerade Bleche, günstig und mit Garantie.",
  },
  grid: {
    ourStock: "Unser Lager",
    itemsInStock: "{{count}} Artikel auf Lager",
    shipping: "Versand in ganz Australien",
    price: "Preis",
    enquire: "Jetzt anfragen",
    searchPlaceholder: "Nach Marke, Modell oder Teil suchen...",
    allMakes: "Alle Marken",
    allModels: "Alle Modelle",
    noResults: "Keine Teile gefunden. Versuchen Sie eine andere Marke oder ein anderes Modell.",
    clearFilters: "Filter zurücksetzen",
  },
  availability: {
    badge: "Lager-Update",
    title: "Gebraucht & Neu {{category}}",
    text: "Wir haben Motoren, Getriebe und Karosserieteile für alle Automarken und -modelle. Wir bieten eine grosse Auswahl an Motoren, Getrieben und Karosserieteilen für europäische, japanische, kanadische und amerikanische Fahrzeuge. Alle Teile werden geprüft und erfüllen die Qualitätsanforderungen, denen sie unterliegen; jeder Artikel ist versiegelt und trägt ein spezielles Kennzeichen. Alle gebrauchten Teile haben eine langfristige Qualitätsgarantie. Wenn Sie Zweifel bei der Wahl Ihres Motors, Getriebes oder Karosserieteils haben, kontaktieren Sie bitte unser Team – wir beantworten gerne Ihre Fragen und beraten Sie umfassend. {{siteName}} – eine bequeme Suche nach gebrauchten & neuen Teilen, mit schneller Lieferung der Ware innerhalb von 1–3 Werktagen nach Zahlungseingang.",
    cta: "Kontakt",
  },
  request: {
    badge: "Teil nicht gefunden?",
    title: "Sie finden das gesuchte Teil nicht?",
    text: "{{siteName}} beschafft jede Woche schwer auffindbare Motoren, Getriebe und Karosserieteile. Nennen Sie uns Marke, Modell und Baujahr — wenn es heute nicht auf Lager ist, spürt unser Team es für Sie auf und meldet sich schnell zurück.",
    cta: "Teil anfragen",
  },
  partsWeSource: {
    badge: "Sonderbestellung",
    title: "Teile, die wir beschaffen",
    desc: "Sie sehen nicht, was Sie suchen? {{siteName}} spürt jede Woche schwer auffindbare Teile auf — von seltenen Steuergeräten und Computerboxen bis zu diesen besonderen Teilen, die sonst niemand führt.",
    ecuTitle: "Steuergeräte & Control Units",
    ecuText: "Motor-, Getriebe- und Karosserie-Steuergeräte, programmiert und passgenau getestet für Ihr Fahrzeug.",
    computerBoxTitle: "Computerboxen",
    computerBoxText: "Motorsteuerungs-Computerboxen und kabelsatzabgestimmte Module für Utes, SUVs und mehr.",
    hardToFindTitle: "Schwer auffindbare Teile",
    hardToFindText: "Seltene Zierleisten, eingestellte Paneele und Spezialteile aus unserem landesweiten Netzwerk.",
    cta: "Teil anfragen",
  },
  contact: {
    badge: "Kontakt aufnehmen",
    title: "Kontakt",
    desc: "Haben Sie ein bestimmtes Teil im Sinn? Senden Sie uns eine Anfrage und unser Team meldet sich umgehend. Wir versenden in ganz Australien von Winnellie, Darwin NT 0820.",
    sendEnquiry: "Anfrage senden",
    formDesc: "Füllen Sie das Formular aus und wir melden uns in Kürze.",
    prefill: "Wir haben das Teil, nach dem Sie fragen, bereits vorausgefüllt. Fügen Sie einfach Ihre Daten und ggf. Anmerkungen hinzu.",
    name: "Name",
    namePlaceholder: "Ihr vollständiger Name",
    email: "E-Mail",
    emailPlaceholder: "sie@email.de",
    phone: "Telefon",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Betreff",
    subjectPlaceholder: "Thema wählen",
    subjectEngine: "Motoranfrage",
    subjectTransmission: "Getriebeanfrage",
    subjectBody: "Karosserieteil-Anfrage",
    subjectGeneral: "Allgemeine Anfrage",
    subjectSpecialOrder: "Sonderbestellung / Teileanfrage",
    part: "Angefragtes Teil / Artikel",
    partPlaceholder: "z. B. Motor – Toyota HiLux 2018",
    vehicle: "Fahrzeug (Marke, Modell & Baujahr)",
    vehiclePlaceholder: "z. B. Toyota HiLux 2018",
    notes: "Anmerkungen",
    notesPlaceholder: "Sagen Sie uns, welches Teil Sie suchen...",
    maxChars: "Max. 500 Zeichen",
    partPhoto: "Foto des Teils (optional)",
    partPhotoHint: "JPG, PNG oder WebP, bis zu 8 MB. Hilft uns, das genaue Teil schneller zu identifizieren.",
    choosePhoto: "Foto auswählen",
    removePhoto: "Foto entfernen",
    photoInvalid: "Bitte wählen Sie eine Bilddatei (JPG, PNG oder WebP).",
    photoTooLarge: "Dieses Bild ist zu groß. Bitte wählen Sie eines unter 8 MB.",
    success: "Vielen Dank für Ihre Anfrage! Wir melden uns in Kürze.",
    sending: "Wird gesendet...",
    send: "Anfrage senden",
    details: "Unsere Daten",
    addressLabel: "Adresse",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    hoursLabel: "Öffnungszeiten",
    sat: "Sa: Nach Vereinbarung",
  },
  detail: {
    home: "Startseite",
    photos: "Fotos",
    specifications: "Spezifikationen",
    make: "Marke",
    model: "Modell",
    year: "Baujahr",
    fitment: "Passform",
    condition: "Zustand",
    warranty: "Garantie",
    notFound: "Dieses Teil konnte nicht gefunden werden. Es wurde möglicherweise verkauft oder entfernt.",
    backHome: "Zur Startseite",
    backToList: "Zurück zur Liste",
  },
};